const initEmailtplData = {
  
}


export function emailtplData(
  state = initEmailtplData,
  action
) {
  switch (action.type) {
    case "EMAIL_TPL_FETCH_DATA_SUCCESS":
      return action.dataEmailtpl;
    default:
      return state;
  }
}
